import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function SlideClose() {
  return <div className="h-full w-full flex flex-col items-center justify-center px-12 py-16 text-center relative overflow-hidden" data-id="element-81">
      {/* Background Glow */}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none" data-id="element-82">
        <div className="w-[800px] h-[800px] bg-teal-400/5 rounded-full blur-[100px]" data-id="element-83" />
      </div>

      <div className="z-10 max-w-4xl w-full space-y-10" data-id="element-84">
        <div className="space-y-6" data-id="element-85">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-serif text-white" data-id="element-86">
            Legacy brands don't need more effort.
          </motion.h2>

          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-3xl md:text-5xl font-serif text-teal-400" data-id="element-87">
            They need continuous optimization.
          </motion.h3>
        </div>

        {/* Calculator callback */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="bg-navy-700/40 border border-navy-600 rounded-2xl px-8 py-6 max-w-xl mx-auto" data-id="element-88">
          <p className="text-white/50 text-sm uppercase tracking-widest font-medium mb-2" data-id="element-89">
            Remember the upside you calculated
          </p>
          <p className="text-xl text-white/80" data-id="element-90">
            Even a{' '}
            <span className="text-teal-400 font-semibold" data-id="element-91">5% improvement</span>{' '}
            on mature brands can unlock{' '}
            <span className="text-teal-400 font-semibold" data-id="element-92">
              hundreds of millions
            </span>{' '}
            in value — with the right operating model.
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="text-xl md:text-2xl text-white/70 font-medium max-w-2xl mx-auto" data-id="element-93">
          Turn declining attention into actively managed profit.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 1.1,
        type: 'spring'
      }} className="pt-6" data-id="element-94">
          <Button variant="primary" className="px-10 py-5 text-xl shadow-[0_0_30px_rgba(0,212,170,0.3)] hover:shadow-[0_0_50px_rgba(0,212,170,0.5)]" data-id="element-95">
            Explore pilot
          </Button>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.4
    }} className="absolute bottom-12 text-sm text-white/40 font-medium tracking-widest uppercase" data-id="element-96">
        2 brands × 3–5 markets · 12 weeks · measurable impact
      </motion.div>
    </div>;
}